import { render, staticRenderFns } from "./FeatureBoxes.vue?vue&type=template&id=23a29baa&"
import script from "~/themes/oknanebodvere/components/content/FeatureBoxes/FeatureBoxes.js?vue&type=script&lang=js&"
export * from "~/themes/oknanebodvere/components/content/FeatureBoxes/FeatureBoxes.js?vue&type=script&lang=js&"
import style0 from "./FeatureBoxes.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FeatureBoxes.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Foknadverenamiru%2Fcomponents%2Fcontent%2FFeatureBoxes%2FFeatureBoxes.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports